/* ===== data/npcs.js — NPC · 상인 · 마을 대화 · 대사 ===== */
/* data.js 에서 나눈 표 — data.js 다음 층에서 소스 순서대로 읽힌다 */

/* ---------------- NPC ---------------- */
export const NPCS: Record<string, NpcDef> = {
  elara:  { n: '엘라라', i: '🧝‍♀️', c: '#c8a06a', role: '캠프 관리인', art: 'elara' },
  /* disc — 이 사람에게 살 때 붙는 할인. */
  borin:  { n: '보린', i: '🧔', c: '#8a6a4a', role: '대장장이', disc: 0.4, shop: ['pick_iron', 'sword_iron', 'helm_iron', 'potion_hp_small', 'potion_iron', 'torch', 'band_worn', 'watering_can', 'bucket'], art: 'borin' },
  mira:   { n: '미라', i: '🧙‍♀️', c: '#8f6fd8', role: '마녀', shop: ['staff_branch', 'potion_mp_small', 'ring_focus', 'potion_str'], art: 'mira' },
  old:    { n: '이름 없는 노인', i: '👴', c: '#9a9a9a', role: '???', art: 'elder' },
  /* --- 여명 마을 주민 (세션 1 종장 이후) --- */
  tamer:  { n: '리카', i: '🦝', c: '#b8804a', role: '조련사', art: 'rika', shop: ['egg_common', 'egg_rare', 'egg_epic', 'pet_candy', 'mount_horse'], pets: true,
            line: '짐승들이 낯을 좀 가리긴 해도, 알만 있으면 금방 정든다.' },
  trainer:{ n: '가른', i: '🐺', c: '#5a6a5a', role: '훈련소 교관', art: 'garn',
            line: '잿빛이 걷혔다고 몸이 저절로 강해지진 않아. 굴러야지.' },
  haran:  { n: '하란', i: '🍺', c: '#c06a3a', role: '여관 주인', art: 'haran',
            line: '방은 얼마든지 있어. 이 도시엔 아직 사람보다 방이 많거든.' },
  seira:  { n: '세이라', i: '🔨', c: '#7a8fb8', role: '재련사', art: 'seira',
            line: '물건은 그대로 두고 이름만 바꿔 주는 거야. 운이 나쁘면 더 나빠지고.' },
  kade:   { n: '케이드', i: '⚙', c: '#8a8a96', role: '기술자', art: 'kade', shop: ['charm_cap', 'charm_conduit', 'battery_cell', 'circuit', 'm_sprinkler'],
            line: '이 도시, 사람이 지은 게 아니야. 그럼 누가 지었냐고? 그걸 알아내는 게 내 일이고.' },
  /* 떠돌이 상인 셋 — 마을이 커질수록 하나씩 늘어난다(1·3·4단계). */
  pedlar:  { n: '허윤', i: '🎒', c: '#c8925a', role: '잡화상', art: 'pedlar', dynamicShop: true,
             line: '오늘 실은 건 이게 전부요. 내일 오면 또 다른 게 있을 거고.' },
  /* 가라앉은 도시의 마지막 주민. */
  yunseul: { n: '윤슬', i: '🫧', c: '#7fb8d8', role: '가라앉은 도시의 마지막 사람', art: 'yunseul', dynamicShop: true,
             from: 15,          // 대사 묶음이 15장(세션 3 서장)부터 시작한다
             line: '위로 올라간 사람은 아무도 안 돌아왔어. 그래서 나는 안 올라가기로 했지.' },
  oreman:  { n: '도경', i: '⛏', c: '#8a7a5a', role: '재료상', art: 'oreman', dynamicShop: true,
             line: '캐 오는 건 자네 몫이지만, 급하면 내 것을 사 가게. 값은 좀 치러야지.' },
  armsman: { n: '벽산', i: '🛡', c: '#7a6a8a', role: '장비상', art: 'armsman', dynamicShop: true,
             line: '자네 손에 맞는 것만 내놓네. 들지도 못할 걸 팔아 봐야 서로 손해니까.' }
};
/* 여명 마을 주민 — 종장 전에는 아예 등장하지 않으므로 별도 잠금 대사가 필요 없다 */
export const DAWN_NPCS = ['tamer', 'trainer', 'haran', 'seira', 'kade', 'pedlar', 'oreman', 'armsman'];

/* ---------------- 떠돌이 상인 ---------------- */

/* 장비상이 절대 취급하지 않는 것 — 보스·스토리 산출물. */
export const SHOP_DENY = new Set([
  'sword_first', 'hammer_still', 'crossbow_first', 'tome_first', 'blade_arche', 'tome_origin',
  'lance_orbit', 'bow_meridian', 'hammer_cave', 'sword_arc', 'gun_rail', 'saw_auto', 'drill_abyss',
  'charm_govern', 'charm_orbit', 'charm_maker', 'charm_zenith', 'jetpack', 'charm_lamp2',
  'helm_exo', 'chest_exo', 'boots_exo', 'helm_aether', 'chest_aether', 'boots_aether',
  'pick_arc', 'pick_soul',
  /* 윤슬 전용 — 다른 상인의 equipPool이 ITEMS를 훑어 뽑으므로, 막지 않으면 벽산(장비상) 재고에 그대로 섞여 "유일한 경로"가 아니게 된다 */
  'amul_scale', 'charm_bell', 'ring_deep', 'sigil_current', 'mace_bell', 'harpoon_lamp'
]);

export const MERCHANTS = [
  /* --- 윤슬 (비밀 상점) --- */
  {
    npc: 'yunseul', lv: 1, slots: 5, markup: 1.6, spot: null as Bag | null,
    pool: [
      // 고유 장신구 — 여기서만 나온다.
      { id: 'amul_scale', w: 3 }, { id: 'charm_bell', w: 3 },
      { id: 'ring_deep', w: 3 }, { id: 'sigil_current', w: 3 },
      // 고유 무기 2종 — 더 귀하다
      { id: 'mace_bell', w: 2 }, { id: 'harpoon_lamp', w: 2 },
      // 바다 계열 무기 — 4단계 시설이 없어도 손에 넣을 수 있는 우회로
      { id: 'spear_tide', w: 4 }, { id: 'blade_shark', w: 4 },
      { id: 'bow_harpoon', w: 4 }, { id: 'orb_abyss', w: 4 },
      // 포션 — 물속에서 쓸 것 위주.
      { id: 'potion_hp_greater', w: 12, max: 4 }, { id: 'potion_mp_greater', w: 10, max: 4 },
      { id: 'potion_glow_greater', w: 10, max: 3 }, { id: 'potion_iron', w: 8, max: 3 },
      { id: 'potion_str', w: 7, max: 3 },
      // 잠수 소모품 — 숨이 곧 자원인 곳이라 이게 값을 한다
      { id: 'jelly_lamp', w: 8, max: 6 }, { id: 'abyss_pearl', w: 5, max: 3 },
      { id: 'pressure_plate_m', w: 6, max: 6 }, { id: 'rope_kelp', w: 6, max: 8 },
      // 드래곤 알 넷 · 첫 먹이 — 가라앉은 도시가 품고 있던 것
      { id: 'egg_dragon_fire', w: 2, max: 1 }, { id: 'egg_dragon_earth', w: 2, max: 1 },
      { id: 'egg_dragon_storm', w: 2, max: 1 }, { id: 'egg_dragon_dark', w: 2, max: 1 },
      { id: 'dragon_treat_1', w: 5, max: 3 }
    ]
  },
  {
    npc: 'pedlar', lv: 1, slots: 6, markup: 1.22,
    // 광장 좌판 — 2층이 아직 없는 단계라 길에 선다
    spot: { kind: 'plaza', off: -13 },
    pool: [
      // --- 세션 2(마을이 열리는 시점)의 기본 살림 ---
      { id: 'potion_hp', w: 10, max: 5 }, { id: 'potion_mp', w: 10, max: 5 },
      { id: 'potion_hp_greater', w: 6, max: 3 }, { id: 'potion_mp_greater', w: 6, max: 3 },
      { id: 'torch', w: 7, max: 20 }, { id: 'food_pie', w: 6, max: 4 },
      { id: 'food_soup', w: 6, max: 4 }, { id: 'food_mstew', w: 5, max: 3 },
      { id: 'food_tea', w: 5, max: 3 }, { id: 'food_jelly', w: 4, max: 3 },
      { id: 'potion_glow', w: 5, max: 3 }, { id: 'potion_str', w: 4, max: 2 },
      { id: 'potion_iron', w: 4, max: 2 }, { id: 'seed_wheat', w: 5, max: 8 },
      { id: 'seed_starroot', w: 4, max: 6 }, { id: 'seed_ashcap', w: 3, max: 6 },
      { id: 'fertilizer', w: 4, max: 6 }, { id: 'platform', w: 4, max: 30 },
      { id: 'plank', w: 4, max: 30 }, { id: 'brick', w: 3, max: 30 },
      // --- 4단계(교역지)부터 좋은 것이 섞인다 ---
      { id: 'potion_glow_greater', w: 4, max: 2, vlv: 4 },
      { id: 'potion_str_greater', w: 3, max: 2, vlv: 4 },
      { id: 'potion_iron_greater', w: 3, max: 2, vlv: 4 },
      { id: 'food_feast', w: 3, max: 2, vlv: 4 },
      { id: 'food_curry', w: 3, max: 2, vlv: 4 },
      { id: 'rod_adv', w: 2, max: 1, vlv: 4 }
      // 세션 3 물건은 그 지역이 생기면 sess: 3 으로 여기 붙인다
    ]
  },
  {
    npc: 'oreman', lv: 3, slots: 7, markup: 1.3,
    spot: { kind: 'floor2', block: 2, off: 3 },   // 재련집 2층
    pool: [
      /* 마을은 세션 2에 열린다 — 그 시점 제작이 강철·회로 쪽이라 그쪽을 주로 판다. */
      { id: 'iron_ore', w: 7, max: 14 }, { id: 'iron_bar', w: 7, max: 10 },
      { id: 'coal', w: 7, max: 14 }, { id: 'steel_plate', w: 7, max: 10, sess: 2 },
      { id: 'gear_basic', w: 6, max: 8, sess: 2 }, { id: 'wire', w: 6, max: 10, sess: 2 },
      { id: 'circuit', w: 5, max: 6, sess: 2 }, { id: 'rivet', w: 6, max: 12, sess: 2 },
      { id: 'lead_ore', w: 5, max: 12 }, { id: 'lead_bar', w: 5, max: 8 },
      { id: 'polymer', w: 4, max: 6, sess: 2 }, { id: 'refined_oil', w: 4, max: 6, sess: 2 },
      { id: 'crude_oil', w: 4, max: 8, sess: 2 }, { id: 'motor', w: 3, max: 4, sess: 2 },
      { id: 'battery_cell', w: 3, max: 3, sess: 2 }, { id: 'machine_frame', w: 2, max: 3, sess: 2 },
      { id: 'gold_ore', w: 4, max: 8 }, { id: 'gold_bar', w: 3, max: 5 },
      { id: 'mythril_ore', w: 3, max: 6 }, { id: 'mythril_bar', w: 2, max: 4 },
      { id: 'crystal', w: 4, max: 6 }, { id: 'spider_silk', w: 4, max: 8 },
      { id: 'wood', w: 3, max: 20 }, { id: 'stone', w: 3, max: 20 },
      { id: 'fern_frond', w: 3, max: 10 }, { id: 'vine_coil', w: 3, max: 8 },
      // --- 마을 4단계: 교역로가 열려 귀한 것도 들어온다 ---
      { id: 'aether_shard', w: 2, max: 4, vlv: 4 },
      { id: 'core_shard', w: 2, max: 4, vlv: 4 },
      { id: 'power_core', w: 2, max: 3, vlv: 4, sess: 2 },
      { id: 'conduit_part', w: 3, max: 5, vlv: 4, sess: 2 }
      // 세션 3 재료(화약 원료 등)는 그 지역이 생기면 sess: 3 으로 붙인다
    ]
  },
  {
    npc: 'armsman', lv: 4, slots: 6, markup: 1.45,
    spot: { kind: 'floor2', block: 1, off: 3 },   // 조련사집 2층
    // 무기·갑옷·장신구를 레벨에 맞춰 그때그때 뽑는다
    equip: { types: ['weapon', 'armor', 'acc'], lvSlack: 3 }
  }
];


/* ---------------- 마을 단계별 주민 한 마디 ---------------- */
export const VILLAGE_TALK: Bag = {
  tamer: [null,
    '짐승들이 아직 이 거리를 못 미더워해. 하긴 나도 그래.',
    '가로등이 서니까 밤에도 알을 돌볼 수 있어. 그전엔 해 지면 그냥 접었거든.',
    '성문이 닫히는 소리에 애들이 놀라. 며칠이면 익숙해지겠지.'],
  trainer: [null,
    '터는 넓은데 사람이 없어. 훈련은 혼자서도 되지만, 재미는 없지.',
    '2층이 생겨서 위층에서 아래를 내려다보며 자세를 봐 준다. 훨씬 낫더군.',
    '경비 둘이 문에 섰다고 몸을 놓지 마라. 벽은 사람을 대신하지 않아.'],
  haran: [null,
    '방은 얼마든지 있어. 채울 사람이 없을 뿐이지.',
    '지붕에 기와를 얹었더니 비 오는 밤에 손님이 는다. 소리가 좋아서라나.',
    '요새라니. 간판을 바꿔야 하나 싶다가도, 여관은 여관이지.'],
  seira: [null,
    '풀무가 낡았어. 그래도 도는 게 어디야.',
    '풍차 덕에 밤에도 불을 살려 둔다. 전주 선로가 여기까지 와 있거든.',
    '성벽 쌓느라 성벽돌을 그렇게 벼렸는데, 이젠 손이 다 기억해.'],
  kade: [null,
    '이 도시, 사람이 지은 게 아니야. 아직 그 얘긴 접어 두자고.',
    '서쪽에 울타리 친 땅 봤어? 흙은 골라 뒀는데 아무도 안 갈았어. 괭이 든 사람 기다리는 중이지.',
    '포탑 두 기, 대갈못만 채워 두면 알아서 쏜다. 채우는 건 자네 몫이고.']
};

/* ---------------- 모험가를 이름으로 부르는 한 마디 ----------------
   상황 한 줄 앞에 가끔(NAME_CALL_P) 붙는다. {name} 은 새 게임 창의 이름, 비웠으면 캐릭터 이름.
   ★ {name} 뒤에 조사를 붙이지 말 것 — 플레이어가 영문·숫자로 지은 이름에는 받침 판정이 맞지 않는다. */
export const NAME_CALL_P = 0.3;
export const NAME_CALL: Record<string, string[]> = {
  elara: ['{name}, 왔구나.', '어서 와, {name}. 얼굴 보니 됐다.', '{name}. 오늘은 늦지 않았네.'],
  borin: ['왔나, {name}.', '{name}, 연장은 잘 쓰고 있나.', '또 왔군, {name}. 이번엔 뭘 부러뜨렸어.'],
  mira: ['{name}. 네 이름에서 재 냄새가 나.', '어서 와, {name}. 조각은 아직 따뜻해.', '{name}, 오늘 별은 조용해.'],
  old: ['{name}… 그래, 그 이름이었지.', '왔는가, {name}.', '{name}. 이름을 기억해 두는 건 늙은이 몫이야.'],
  tamer: ['{name}! 애들이 먼저 알아보더라.', '왔어, {name}? 알 좀 같이 봐 줄래?', '{name}, 오늘은 누굴 데려왔어?'],
  trainer: ['{name}. 자세부터.', '왔나, {name}. 쉬었으면 굴러라.', '{name}, 어제보다 나아졌나.'],
  haran: ['{name}! 방 비워 뒀어.', '어이, {name}. 한잔할 시간은 없겠지.', '{name}, 오늘 소문은 전부 네 얘기더라.'],
  seira: ['{name}. 이번엔 뭘 벼릴까.', '왔네, {name}. 운은 챙겨 왔어?', '{name}, 손에 쥔 거 보여 줘.'],
  kade: ['{name}, 마침 잘 왔네.', '왔는가, {name}. 기계가 또 이상한 소리를 내.', '{name}. 오늘은 무슨 부품을 들고 왔나.']
};

/* ================= 사람들이 지금을 보고 하는 말 ================= */
export const TALK_MOODS = [
  { id: 'grave',      when: (c: any) => c.grave },                       // 어딘가에 죽은 자리를 두고 왔다
  { id: 'hurt',       when: (c: any) => c.hpr < 0.35 },                   // 피가 3분의 1 아래
  { id: 'bloodmoon',  when: (c: any) => c.ev === 'bloodmoon' },
  { id: 'sandstorm',  when: (c: any) => c.ev === 'sandstorm' },
  { id: 'sporebloom', when: (c: any) => c.ev === 'sporebloom' },
  { id: 'rain',       when: (c: any) => c.ev === 'rain' },
  { id: 'chdone',     when: (c: any) => c.complete },                     // 이 장에서 할 일을 다 했다
  { id: 'goal',       when: (c: any) => c.ready },                        // 준비는 끝났고 마지막 하나만 남았다
  { id: 'broke',      when: (c: any) => c.gold < 40 },
  { id: 'rich',       when: (c: any) => c.gold >= 5000 },
  /* 세션 2 — 별이 하늘로 돌아간 뒤. */
  { id: 'night2',     when: (c: any) => c.session === 2 && c.night },
  { id: 'night',      when: (c: any) => c.night },
  { id: 'dawn',       when: (c: any) => c.hour >= 5 && c.hour < 8 },
  { id: 'day2',       when: (c: any) => c.session === 2 },
  { id: 'day',        when: () => true }
];

/* say: 상황 한 줄(순번으로 돌아간다) · re: 그 상황에서 할 수 있는 대답과 대꾸 대꾸(s)는 한 줄이어도 되고 여러 줄이어도 된다. */
export const TALK: Bag = {
  /* ---------------- 베이스캠프 ---------------- */
  elara: {
    grave: { say: [
        '어디에 두고 왔니. …아니, 말 안 해도 돼. 지도에 표시가 남아 있을 거야.',
        '네 짐이 어딘가에 떨어져 있다는 건, 나한테는 네가 어딘가에 떨어졌다는 소리로 들려.'],
      re: [
        { t: '금방 찾아올게.', s: '금방이 아니어도 돼. 돌아오기만 해.' },
        { t: '그냥 버릴까 싶어.', s: '그럴 수 있으면 그래. …나는 아직 아무것도 못 버렸어.' }] },
    hurt: { say: [
        '앉아. 이건 부탁이 아니라 관리인 권한이야.',
        '너 지금 걷는 게 아니라, 넘어지면서 앞으로 가고 있어.',
        '피 냄새를 달고 들어오지 마. 여기 사람들 그거 알아본다.'],
      re: [
        { t: '괜찮아.', s: '괜찮은 사람은 그 말을 안 해.' },
        { t: '약이 떨어졌어.', s: '보린한테 가. 내 이름 대면 하나쯤은 그냥 줄 거야.' }] },
    bloodmoon: { say: [
        '달이 붉지. 문은 닫아 뒀어. 두드릴 사람은 너뿐이니까.',
        '붉은 밤엔 다들 조용해져. 짐승도, 사람도. 그게 더 무서워.'],
      re: [
        { t: '그래도 나가야 해.', s: '알아. 다녀와서 문 두드려. 안 자고 있을게.' },
        { t: '오늘은 여기 있을게.', s: '…고맙다. 그 말 들으려고 밤새 앉아 있었나 봐.' }] },
    sandstorm: { say: [
        '옷에 모래가 그렇게 붙어서 들어오면 안 되지. 털고 와.',
        '사막 쪽이 통째로 움직였다며. 여기까지 바람이 왔어.'],
      re: [
        { t: '사막 쪽은 좀 잠잠해?', s: '잠잠한 적이 없었어. 요즘은 그게 더 시끄러워졌을 뿐이고.' }] },
    sporebloom: { say: [
        '골짜기에서 뭔가 터졌다지. 냄새가 여기까지 와.',
        '숨을 얕게 쉬어. 그 냄새가 옷에 배면 오래 가.'],
      re: [
        { t: '그 냄새 위험한가?', s: '미라한테 물어. 나는 냄새가 난다는 것밖에 몰라.' }] },
    rain: { say: [
        '처마 밑으로 들어와. 이 비는 씻어 주는 비가 아니야.',
        '재가 녹아서 내려오는 거야. 오래 맞으면 옷부터 삭아.'],
      re: [
        { t: '비 오면 놈들이 사나워지던데.', s: '맞아. 젖은 날엔 다들 성질이 나빠져. 짐승도 사람도.' }] },
    chdone: { say: [
        '얼굴이 좀 폈네. 뭔가 매듭을 지었구나.',
        '오늘은 뭘 물어봐도 다 끝냈다고 할 얼굴이야.'],
      re: [
        { t: '다음은 뭐지?', s: '그건 내가 정하는 게 아니야. 그래도 하루쯤은 쉬어도 돼.' }] },
    broke: { say: [
        '주머니가 비었지. 표정에 다 나와.',
        '돈 얘기는 안 하려고 했는데 — 너 지금 아무것도 못 사겠구나.'],
      re: [
        { t: '빌려줄 수 있어?', s: '없어. 대신 게시판을 봐. 의뢰는 늘 돈보다 먼저 와 있어.' }] },
    rich: { say: [
        '그 금화 다 어디서 났니. …아니, 정말 묻는 건 아니야.',
        '가방이 무거워 보인다. 무거운 걸 들고 다니면 발이 느려져.'],
      re: [
        { t: '좀 나눠 줄까?', s: '됐어. 여기 있는 건 나 혼자 쓸 만큼은 돼. 네가 써.' }] },
    night: { say: [
        '이 시간에 깨어 있는 건 너랑 나뿐이야.',
        '밤엔 소리가 멀리 가. 그래서 나는 밤에 문을 안 열어.',
        '자라고는 안 할게. 나도 안 자니까.'],
      re: [
        { t: '왜 안 자?', s: ['누가 돌아올지 모르잖아.', '한 번은 문을 잠그고 잤어. 그날 밤에 두드린 사람이 있었고.'] }] },
    dawn: { say: [
        '새벽 공기가 제일 맑아. 재가 아직 안 떠서 그래.',
        '해가 뜨면 밤새 뭐가 왔다 갔는지 자국이 보여. 오늘은 깨끗하네.'],
      re: [
        { t: '다녀올게.', s: '…그 말, 매번 잘 지켜 줘서 고마워.' }] },
    goal: { say: [
        '준비는 다 된 것 같은데. 이제 남은 건 하나지.',
        '문 앞에서 오래 서 있지 마. 그게 제일 힘든 자리야.'],
      re: [
        { t: '무섭긴 해.', s: '무서운 게 정상이야. 안 무서우면 그게 더 걱정이고.' }] },
    night2: { say: [
        '이제 밤에도 문을 열어 둬. 무섭지가 않아졌어.',
        '별이 다시 뜬 밤은 몇 번을 봐도 안 익숙해지네.'],
      re: [
        { t: '같이 볼래?', s: '…그러자. 잠깐만, 등불 좀 끄고.' }] },
    day2: { say: [
        '별이 하늘로 돌아간 뒤로 재가 덜 내려. 눈에 보일 만큼.',
        '사람들이 하나둘 돌아오고 있어. 이 캠프도 곧 캠프가 아니게 되겠지.',
        '여명 마을 쪽에 가 봤니? 거기 사람들은 여기 얘기를 안 믿더라.'],
      re: [
        { t: '여기 남을 거야?', s: ['남아야지. 돌아오는 사람이 문을 못 찾으면 안 되잖아.',
                                '나는 그것 하나는 잘해.'] }] },
    day: { say: [
        '오늘도 나갈 거지. 물통은 채웠고?',
        '게시판 한 번 보고 가. 어제 새로 붙인 게 있어.',
        '조심하라는 말은 이제 안 할게. 네가 안 듣는 걸 아니까.'],
      re: [
        { t: '오늘은 어디로 가면 좋을까?', s: '네가 정해. 나는 문만 열어 둘게.' }] }
  },

  borin: {
    grave: { say: [
        '연장을 두고 왔지. 쇠는 땅에 오래 두면 상해.',
        '그 자리에 다시 가는 게 무섭거든, 나한테 위치나 말해 두게. 기억은 해 줄 테니.'],
      re: [
        { t: '다시 만들어 줄 수 있어?', s: '만들지. 대신 광석은 자네가 캐 와. 나는 그것까진 못 해.' }] },
    hurt: { say: [
        '갑옷이 아니라 자네가 우그러졌군.',
        '망치질할 손이 그 꼴이면 아무것도 못 잡네. 앉게.'],
      re: [
        { t: '방어구를 손봐 줘.', s: '가져와 보게. 쇠는 고치면 되지만 사람은 그렇지가 않아서 말이야.' }] },
    bloodmoon: { say: [
        '오늘은 화로를 안 끄고 잘 걸세. 붉은 밤엔 불빛이 벽이야.',
        '저 달이 뜨면 쇠가 이상하게 잘 먹어. 이유는 나도 모르지.'],
      re: [
        { t: '같이 있어 줄까?', s: '…화로 옆에 앉게. 말은 안 해도 되네.' }] },
    sandstorm: { say: [
        '모래바람 부는 날엔 화로를 못 열어. 재가 아니라 모래가 들어와서.',
        '자네 갑옷 이음새에 모래가 꼈군. 그거 그냥 두면 안에서 갈아 먹네.'],
      re: [
        { t: '모래 좀 털어 줘.', s: '이음새를 벌려서 털어야 하네. 앉게, 시간 좀 걸려.' }] },
    dawn: { say: [
        '이 시간에 벌써 왔나. 화로가 아직 안 데워졌네.',
        '새벽 쇠는 무르다네. 조금만 기다리게.'],
      re: [
        { t: '기다릴게.', s: '그럼 풀무나 밟아 주게. 공짜로 기다리는 건 없네.' }] },
    rain: { say: [
        '비 오는 날엔 담금질이 잘 돼. 물이 저 혼자 식혀 주거든.',
        '젖은 채로 화로 옆에 서지 말게. 김이 올라와서 눈이 상해.'],
      re: [
        { t: '오늘은 뭘 벼릴 거야?', s: '못. 아무도 안 사 가는데 계속 만들어. 손이 심심해서 그래.' }] },
    chdone: { say: [
        '무기에 자국이 늘었군. 좋은 자국이야.',
        '자네가 뭘 끝내고 오면 화로 소리가 다르게 들려. 착각이겠지만.'],
      re: [
        { t: '무기 좀 봐 줘.', s: '날이 무뎌졌군. 두고 가게, 아침까지 세워 놓을 테니.' }] },
    broke: { say: [
        '외상은 안 돼. …라고 말하고 싶지만 얼굴이 그 모양이면 어쩌겠나.',
        '돈이 없으면 광석을 캐 오게. 쇠는 언제나 돈보다 정직해.'],
      re: [
        { t: '광석 시세는 어때?', s: '싸. 아무도 안 캐는데 아무도 안 사. 그래서 쌀 수밖에.' }] },
    rich: { say: [
        '주머니 소리가 좋군. 그 소리 오래 못 갈 걸세, 내가 다 받아낼 테니.',
        '돈이 있을 때 방어구를 사 두게. 무기는 급할 때 사도 늦지 않아.'],
      re: [
        { t: '제일 좋은 걸로 줘.', s: '제일 좋은 건 아직 안 만들었네. 자네가 광석을 가져오면 그때.' }] },
    night: { say: [
        '이 시간까지 화로를 살려 두는 건 나뿐이야. 밤엔 쇠가 조용하거든.',
        '망치 소리가 시끄럽거든 말하게. …아니, 말해도 안 멈추네.'],
      re: [
        { t: '안 자?', s: '자네가 안 자는데 내가 어떻게 자나.' }] },
    goal: { say: [
        '연장은 다 챙겼나. 그럼 이제 자네 차례군.',
        '남은 게 하나면, 그 하나가 제일 무겁다네.'],
      re: [
        { t: '이 무기로 될까?', s: '되네. 안 되면 자네가 안 되는 거지 쇠가 안 되는 게 아니야.' }] },
    night2: { say: [
        '밤에 망치를 안 들어도 되는 날이 오다니.',
        '요즘은 밤에 잠이 오네. 그게 제일 신기해.'],
      re: [
        { t: '잘 자.', s: '자네도. …그 말도 오랜만이군.' }] },
    day2: { say: [
        '요즘은 무기보다 문고리 주문이 많아. 좋은 일이지.',
        '여명 마을 재련사가 나보다 낫다더군. 한 번 가 볼까 하네.'],
      re: [
        { t: '가 보는 게 어때?', s: '무릎이. …아니지, 핑계군. 생각해 보겠네.' }] },
    day: { say: [
        '어서 오게. 오늘은 뭘 부러뜨려 왔나.',
        '가죽이든 뼈든 버리지 말게. 그런 걸로도 만들 수 있는 게 있어.',
        '무릎이 예전 같지 않아. 그래서 자네가 대신 걷는 거고.'],
      re: [
        { t: '요즘 뭘 만들고 있어?', s: ['못, 경첩, 문고리. 사람이 살려면 그런 게 먼저야.', '무기는 그 다음이지. …요즘은 순서가 뒤바뀌었지만.'] }] }
  },

  mira: {
    grave: { say: [
        '네 것이 아직 저 밖에 있어. 물건 말고, 조각 얘기야.',
        '죽은 자리에는 잠깐 꿈이 고여. 오래 두면 다른 게 그 꿈을 꿔.'],
      re: [
        { t: '위험한 거야?', s: ['조각이 하는 짓과 똑같아. 규모만 작을 뿐이야.', '그러니 빨리 가져와.'] }] },
    hurt: { say: [
        '네 안의 별빛이 흔들려. 몸이 아니라 그게 먼저 다쳐.',
        '피를 그만큼 흘리면 빛도 같이 새. 나는 그게 더 걱정이야.'],
      re: [
        { t: '빛이 다 새면?', s: '그때는 조각을 만져도 아무 일이 없겠지. 좋은 일처럼 들리지만 아니야.' }] },
    bloodmoon: { say: [
        '오늘 달은 별이 아니야. 별인 척하는 거지.',
        '붉은 밤엔 조각들이 서로를 부르는 소리가 커져. 나는 그게 들려.'],
      re: [
        { t: '뭐라고 부르는데?', s: ['말이 아니야. 굳이 옮기면 — "여기 있어".', '외로운 것들이 하는 말이 늘 그래.'] }] },
    sporebloom: { say: [
        '골짜기가 숨을 뱉었어. 포자가 여기까지 오진 않지만, 냄새는 와.',
        '저건 번식이 아니라 꿈이 퍼지는 거야. 조각을 오래 곁에 둔 땅이 그렇게 돼.'],
      re: [
        { t: '퍼지면 어떻게 돼?', s: '땅이 제 이름을 잊어. 사람도 그 위에 오래 있으면 비슷해지고.' }] },
    sandstorm: { say: [
        '모래가 움직이는 건 바람 때문이 아니야. 아래에서 뭔가 뒤척여서 그래.',
        '사구 밑에도 조각이 하나 잠들어 있어. 뒤척일 때마다 사막이 자리를 옮기고.'],
      re: [
        { t: '사막 밑에도 조각이 있어?', s: ['있었어. 지금은 없고.', '그 자리가 아직 뒤척이는 거야.'] }] },
    rain: { say: [
        '비가 재를 씻어 내리면 땅이 잠깐 제 색을 기억해. 잠깐이야.',
        '오늘 같은 날엔 마력이 무거워. 주문이 반 박자 늦게 나가니까 조심해.'],
      re: [
        { t: '주문이 늦으면 어떡해?', s: '늦은 만큼 물러서. 그게 전부야.' }] },
    chdone: { say: [
        '조각 하나가 조용해졌어. 네 손에서 나는 빛이 방금 한 겹 두꺼워졌고.',
        '잘 재웠구나. 죽인 게 아니라 재운 거야. 그 차이를 기억해 둬.'],
      re: [
        { t: '재웠다는 게 무슨 뜻이야?', s: ['죽인 게 아니라는 뜻이야. 다시 깨울 수도 있다는 뜻이고.', '…그건 나중에 걱정하자.'] }] },
    broke: { say: [
        '돈이 없구나. 나는 돈을 안 받는 대신 더 나쁜 걸 받으니까 차라리 다행이야.',
        '빈손으로 와도 돼. 어차피 내가 파는 건 물건이 아니야.'],
      re: [
        { t: '대신 뭘 받는데?', s: '네 시간. 여기 앉아 있는 동안은 다른 걸 못 하잖아.' }] },
    night: { say: [
        '밤에는 별이 보여. 하나가 빠진 자리도 같이 보이고.',
        '나는 밤에 안 자. 자면 조각들 꿈에 끌려가거든.'],
      re: [
        { t: '무슨 꿈인데?', s: ['남의 꿈이야. 그게 제일 무서워.', '내 꿈이었으면 깨면 그만이잖아.'] }] },
    dawn: { say: [
        '해 뜨기 직전에 마력이 제일 얕아. 지금 나가면 조용할 거야.',
        '새벽엔 조각들도 잠깐 자. 딱 이만큼이 우리 시간이야.'],
      re: [
        { t: '지금 나갈게.', s: '그래. 해가 다 올라오기 전에 돌아와.' }] },
    goal: { say: [
        '길이 하나로 좁아졌어. 이제 돌아가는 길은 없고.',
        '조각이 너를 기다려. 기다린다는 말이 좋은 뜻은 아니야.'],
      re: [
        { t: '준비가 됐을까?', s: ['준비가 다 된 사람은 아무도 없었어.', '그래도 간 사람만 돌아왔지.'] }] },
    night2: { say: [
        '저기, 새로 뜬 자리 보이지. 저게 우리가 올려보낸 거야.',
        '밤이 무섭지 않은 건 태어나서 처음이야.'],
      re: [
        { t: '이제 잘 수 있어?', s: '아직. 그래도 자려고 눕기는 해.' }] },
    day2: { say: [
        '별이 제자리로 갔어. 그런데 내 안의 빛은 아직 안 꺼졌고.',
        '조각들이 조용해. 조용한 게 늘 좋은 건 아니지만.'],
      re: [
        { t: '네 빛은 어때?', s: '아직 타. 다 타면 그때 얘기하자.' }] },
    day: { say: [
        '네 안에서 별빛이 나. 오늘은 어제보다 조금 옅어.',
        '오늘은 별 소리가 잔잔해. 이런 날은 드물어.',
        '무엇을 물어도 대답해 줄게. 대신 대답이 마음에 안 들어도 원망하지 마.'],
      re: [
        { t: '오늘 내 빛은 어때?', s: ['어제보다 조금 옅어. 그게 나쁜 뜻만은 아니야.', '타는 건 줄어드는 거니까. 다 타기 전에 끝내면 돼.'] }] }
  },

  old: {
    hurt: { say: [
        '피는 몸이 아직 자기 것을 지키려 한다는 뜻이다. 나쁘지 않아.',
        '아프냐. …그럼 살아 있는 게지.'],
      re: [
        { t: '죽을 뻔했어요.', s: '그럼 아직 안 죽은 게지. 앉거라.' }] },
    bloodmoon: { say: [
        '저 붉은 것을 달이라 부르지 마라. 이름을 주면 자꾸 온다.',
        '오늘 밤엔 아무것도 묻지 마라. 대답이 이쪽으로 새어 나갈 게다.'] },
    sandstorm: { say: [
        '모래는 물보다 오래 기억한다. 밟은 자리가 한참 남아.',
        '바람이 옮기는 것은 모래가 아니라 자리다.'] },
    sporebloom: { say: [
        '숨을 뱉는 것이 다 살아 있는 것은 아니다. 저건 그냥 터진 게지.',
        '골짜기가 저러는 것을 나는 두 번 보았다. 두 번 다 여름이었지.'] },
    rain: { say: [
        '비가 오는구나. 이 땅이 우는 게 아니라, 그냥 물이 떨어지는 게다. 착각하지 마라.',
        '젖은 채로 서 있지 마라. 늙으면 그게 제일 먼저 온다.'],
      re: [
        { t: '…그렇네요.', s: '그래. 착각을 줄이면 오래 산다.' }] },
    chdone: { say: [
        '하나를 끝냈구나. …끝냈다고 생각하겠지.',
        '잘 했다. 그 말을 여기서 해 주는 사람이 없을 것 같아 내가 한다.'],
      re: [
        { t: '끝난 게 아닌가요?', s: '끝난 것은 늘 하나뿐이다. 그 하나가 무엇이었는지는 나중에 알게 돼.' }] },
    night: { say: [
        '늙으면 잠이 준다. 그래서 밤을 다 보게 돼.',
        '이 시간에 오는 사람은 대개 물을 게 있어서지. 물어라.'],
      re: [
        { t: '뭘 보고 계세요?', s: '밤을. 밤은 볼수록 다르다.' }] },
    goal: { say: [
        '남은 것이 하나면 서두르지 마라. 서두르면 그 하나에 먹힌다.',
        '가거라. 늙은이가 붙잡을 자리가 아니다.'],
      re: [
        { t: '다녀오겠습니다.', s: '그래. 그 말은 돌아온다는 뜻이지.' }] },
    night2: { say: [
        '보이느냐. 저 자리가 원래 자리다.',
        '이제 물을 것이 줄었구나. 그것도 나쁘지 않다.'] },
    day2: { say: [
        '별이 돌아갔다지. …나는 그것을 두 번 보았다.',
        '끝난 것이 아니다. 다만 이번에는 우리 차례가 지났을 뿐이지.'],
      re: [
        { t: '두 번이라니요?', s: ['한 번은 내가 젊었을 때다.', '그때는 아무도 올려보내지 못했지.'] }] },
    day: { say: [
        '왔구나. 오늘은 무엇이 궁금하냐.',
        '앉아라. 서서 듣는 이야기는 남지 않는다.',
        '내가 아는 걸 다 말해 주지는 않는다. 다 말하면 네가 안 갈 테니까.'],
      re: [
        { t: '무엇이든 물어도 되나요?', s: '묻거라. 대답할지는 내가 정한다.' }] }
  },

  /* ---------------- 여명 마을 ---------------- */
  tamer: {
    grave: { say: [
        '짐승들이 네 냄새를 맡고 서쪽을 봐. 뭘 두고 왔구나.',
        '한 마리 데려가. 두고 온 자리까지는 냄새로 찾아 줄 거야.'],
      re: [
        { t: '정말 찾을 수 있어?', s: '못 찾으면 최소한 같이 헤매 주기라도 하지. 사람보다 낫잖아.' }] },
    hurt: { say: [
        '그 몸으로 오면 애들이 먼저 알아. 지금 다 뒤에 숨었어.',
        '피 흘리는 사람 옆엔 짐승이 안 붙어. 미안한데 그건 나도 못 고쳐.'],
      re: [
        { t: '미안, 나중에 올게.', s: '응. 씻고 와. 애들은 안 도망가.' }] },
    bloodmoon: { say: [
        '오늘 밤엔 알들을 다 안으로 들였어. 붉은 달 뜨면 부화가 이상해져.',
        '애들이 아까부터 한쪽만 봐. 저 달을 보는 거야.'],
      re: [
        { t: '이상해진다니?', s: ['제대로 안 깨. 껍데기 안에서 다른 걸 꿈꾸다 나와.', '그래서 오늘은 안 팔아.'] }] },
    sandstorm: { say: [
        '모래바람 불면 애들이 다 굴로 들어가. 본능이지.',
        '자네 발자국에서 모래가 떨어져. 애들이 그거 냄새 맡느라 정신없어.'],
      re: [
        { t: '냄새로 뭘 알아?', s: '어디 갔다 왔는지. 사람보다 정확해.' }] },
    sporebloom: { say: [
        '포자 냄새 나면 애들이 재채기를 해. 귀엽긴 한데 몸엔 안 좋아.',
        '오늘은 문을 다 닫아 뒀어. 애들 코가 사람보다 훨씬 예민하거든.'],
      re: [
        { t: '괜찮은 거야?', s: '하루 이틀이면 가라앉아. 매번 그랬어.' }] },
    rich: { say: [
        '오늘은 좋은 알을 꺼내 놨어. 값을 보면 알 거야.',
        '돈 많은 사람한테는 비싼 애를 권해. 그게 서로한테 좋아.'],
      re: [
        { t: '제일 비싼 애로.', s: '그 말 기다렸어. 잠깐만, 안에서 꺼내 올게.' }] },
    rain: { say: [
        '비 오는 날은 애들이 잘 자. 처마 밑에서 다 뻗어 있어.',
        '젖은 손으로 알 만지지 마. 미끄러워서가 아니라, 애들이 싫어해서.'],
      re: [
        { t: '재우고 갈게.', s: '응. 발소리만 좀 줄여 줘.' }] },
    chdone: { say: [
        '뭘 하고 왔길래 애들이 다 일어나서 봐. 큰 걸 잡았구나.',
        '오늘은 순해 보이네. 짐승은 그런 걸 제일 잘 알아.'],
      re: [
        { t: '큰 걸 하나 잡았어.', s: '그거 냄새가 아직 나. 씻어도 안 지워지는 냄새가 있어.' }] },
    broke: { say: [
        '돈 없으면 알은 못 줘. 대신 쓰다듬는 건 공짜야.',
        '외상? 나는 되는데 애들이 안 된대.'],
      re: [
        { t: '그럼 쓰다듬을게.', s: '그래. 그건 아무리 해도 안 닳아.' }] },
    night: { say: [
        '밤엔 애들이 더 잘 따라. 낮엔 사람이 많아서 그런가 봐.',
        '가로등 아래서 자는 놈이 하나 있는데, 저게 제일 비싸.'],
      re: [
        { t: '저 자는 애 얘기 좀 해 줘.', s: ['이름은 아직 없어. 이름 붙이면 못 팔거든.', '…그래서 안 붙이는 거야.'] }] },
    goal: { say: [
        '애들이 자꾸 문 쪽을 봐. 자네가 곧 나갈 걸 아는 거지.',
        '하나 데려가. 혼자 가는 것보단 나아.'],
      re: [
        { t: '같이 가 줄래?', s: '그럼. 대신 돌아올 때도 같이 와.' }] },
    day: { say: [
        '오늘은 애들이 다 나와 있어. 해가 좋아서 그런가 봐.',
        '이 도시에서 제일 먼저 정착한 게 누군지 알아? 사람 아니야.',
        '알은 고르는 게 아니라 골라지는 거야. …라고 하면 좀 비싸 보이지?'],
      re: [
        { t: '한 마리 데려가도 돼?', s: '돈 내면. 정 들면 더 내고.' }] }
  },

  trainer: {
    grave: { say: [
        '장비를 흘리고 왔다고. 그건 실수가 아니라 버릇이다. 고쳐라.',
        '두고 온 자리로 다시 가는 것까지가 훈련이다. 가라.'],
      re: [
        { t: '가서 가져올게.', s: '가라. 같은 자리에서 두 번 넘어지지만 마라.' }] },
    hurt: { say: [
        '그 상태로 내 앞에 서지 마라. 가르칠 게 없다, 살아 있는 것 말고는.',
        '맞고 온 게 아니라 못 피한 거다. 앉아서 숨부터 골라라.'],
      re: [
        { t: '어떻게 피해야 하지?', s: ['먼저 움직이지 마라. 상대가 먼저 정하게 두고, 그 다음에 움직여라.', '그게 전부다. 나머지는 몸이 배운다.'] }] },
    bloodmoon: { say: [
        '붉은 밤이다. 오늘은 훈련 없다. 성벽 위에 서 있을 거다.',
        '이런 밤에 나가는 놈이 강한 게 아니라, 이런 밤을 세는 놈이 강한 거다.'],
      re: [
        { t: '같이 서 있을게.', s: '…그래. 말은 하지 마라. 소리가 멀리 간다.' }] },
    sandstorm: { say: [
        '모래바람 속에서 눈 뜨는 연습을 해 둬라. 언젠가 그 상황이 온다.',
        '오늘 훈련은 안뜰이다. 밖에서는 자세가 안 보인다.'],
      re: [
        { t: '안뜰이면 좁지 않아?', s: '좁은 데서 익힌 게 넓은 데서도 된다. 반대는 안 되고.' }] },
    sporebloom: { say: [
        '숨을 얕게, 길게. 그게 오늘 배울 전부다.',
        '포자 핀 날엔 뛰지 마라. 뛰면 더 마신다.'],
      re: [
        { t: '그럼 도망은 어떻게 쳐?', s: '도망칠 일을 안 만드는 게 먼저다.' }] },
    rain: { say: [
        '비 오는 날 훈련이 제일 낫다. 발이 미끄러우면 자세가 정직해진다.',
        '젖은 손으로 무기 잡는 법을 오늘 배워 둬라. 언젠가 그 상황이 온다.'],
      re: [
        { t: '젖은 손으로 어떻게 잡아?', s: ['더 세게 잡지 마라. 그러면 더 미끄럽다.', '손목으로 받쳐라. 손가락은 거들 뿐이다.'] }] },
    chdone: { say: [
        '얼굴이 달라졌군. 뭔가를 넘겼구나.',
        '이겼다고 자세가 좋아지진 않는다. 내일도 와라.'],
      re: [
        { t: '내일도 올게.', s: '그 말을 지킨 놈이 지금까지 셋이다. 넷째가 되어 봐라.' }] },
    broke: { say: [
        '수련비가 없으면 몸으로 때워라. 마침 옮길 짐이 있다.',
        '돈이 없다고 약해지는 건 아니다. 약해지는 건 안 굴러서다.'],
      re: [
        { t: '짐은 어디 있지?', s: '저기. 다 옮기면 한 번은 그냥 봐 준다.' }] },
    rich: { say: [
        '주머니가 무거우면 발이 늦다. 오늘은 그거부터 고치자.',
        '돈으로 살 수 있는 건 여기까지다. 그 다음은 굴러야 한다.'],
      re: [
        { t: '수련비를 더 낼게.', s: '값은 정해져 있다. 더 내도 더 안 가르친다.' }] },
    night: { say: [
        '이 시간에 왔다는 건 낮에 못 한 게 있다는 뜻이지. 좋다.',
        '야간 훈련은 반값이다. 대신 두 배로 넘어질 각오는 해라.'],
      re: [
        { t: '지금 훈련할래.', s: '좋다. 대신 소리는 내지 마라. 여관에 사람이 있다.' }] },
    dawn: { say: [
        '새벽에 오는 놈은 오래 간다. 이건 통계다.',
        '해 뜨기 전에 몸을 데워 둬라. 첫 한 방이 제일 느리다.'],
      re: [
        { t: '첫 한 방이 왜 느려?', s: '몸이 아직 어제에 있어서다. 열 번 휘두르면 오늘로 온다.' }] },
    goal: { say: [
        '남은 게 하나라면, 오늘은 훈련보다 잠이다.',
        '몸은 다 됐다. 이제 머리를 비워라.'],
      re: [
        { t: '조언 하나만.', s: ['첫 십 초를 버텨라. 그 다음은 상대가 실수한다.', '다 그렇더군.'] }] },
    day: { say: [
        '왔으면 몸부터 풀어라. 말은 그 다음이다.',
        '스탯을 다시 짜 줄 수는 있다. 대신 왜 그렇게 짰는지는 네가 알아야 한다.',
        '나는 사람을 강하게 만들지 않는다. 안 죽게 만들 뿐이다.'],
      re: [
        { t: '오늘은 뭘 배우면 되지?', s: ['넘어지는 법. 그게 첫 번째다.', '일어나는 법은 두 번째고. 대개 그건 알아서들 하더군.'] }] }
  },

  haran: {
    grave: { say: [
        '어디서 넘어졌다며. 소문은 여관이 제일 빨라.',
        '두고 온 게 있으면 술 한잔 하고 가. 맨정신으로 그 자리 다시 가는 거 아니야.'],
      re: [
        { t: '술은 됐어.', s: '그럼 방이라도. …아니, 알겠어. 조심해서 다녀와.' }] },
    hurt: { say: [
        '그 꼴로 계단 오르지 마. 1층에 방 하나 남겨 뒀어.',
        '피는 시트에 안 지워져. 그래도 자고 가. 시트는 내가 알아서 해.'],
      re: [
        { t: '방 값이 없어.', s: '오늘은 받은 걸로 할게. 대신 다음에 두 배로 받는다.' }] },
    bloodmoon: { say: [
        '붉은 달 뜬 밤엔 손님이 는다. 다들 나가기 싫어하거든.',
        '오늘은 문을 일찍 닫아. 자네만 늦게 두드려도 열어 줄게.'],
      re: [
        { t: '문 열어 둘 수 있어?', s: '자네가 두드리면. 다른 사람은 안 돼.' }] },
    sandstorm: { say: [
        '창틀 사이로 모래가 들어와. 하루 종일 쓸고 있어.',
        '모래 씹히는 술은 팔 수가 없지. 오늘은 뚜껑 덮은 것만 내갈게.'],
      re: [
        { t: '쓸어 줄까?', s: '손님한테 빗자루를 쥐여 주는 여관이 어디 있나. …그래도 고맙군.' }] },
    sporebloom: { say: [
        '문 닫아 뒀어. 그 냄새가 방에 배면 손님이 안 자.',
        '포자 핀 날엔 이상하게 다들 오래 앉아 있어. 말수가 줄고.'],
      re: [
        { t: '다들 왜 말이 없어?', s: '그 냄새 맡으면 옛날 생각이 난대. 나도 그렇고.' }] },
    rain: { say: [
        '지붕에 기와 얹은 보람이 오늘이지. 소리 좋잖아.',
        '비 오는 날은 술이 잘 팔려. 슬퍼서가 아니라 나갈 데가 없어서야.'],
      re: [
        { t: '한잔 주게.', s: ['이 시간에? …좋아, 딱 한 잔.', '취해서 나가면 내가 욕먹어.'] }] },
    chdone: { say: [
        '표정 보니 오늘은 축하할 일이 있구먼. 한 잔은 내가 낸다.',
        '큰일 끝내고 오는 사람은 걸음이 달라. 나는 그걸로 안다.'],
      re: [
        { t: '고마워.', s: '고맙긴. 자네가 살아 돌아오는 게 내 장사야.' }] },
    broke: { say: [
        '주머니 사정 알아. 오늘은 물이라도 공짜로 줄게.',
        '돈 없는 손님이 제일 오래 앉아 있어. 그래서 나는 그 손님이 좋아.'],
      re: [
        { t: '물이면 충분해.', s: '…그렇게 말하는 손님이 제일 마음에 걸려.' }] },
    rich: { say: [
        '오늘은 좋은 방으로 드리지. 값도 좋은 값으로 받고.',
        '금화 소리가 나는군. 이 도시에서 그 소리 나는 사람은 자네뿐이야.'],
      re: [
        { t: '제일 좋은 방으로.', s: '3층. 창이 동쪽이야. 해 뜨는 게 보여.' }] },
    night: { say: [
        '이 시간에 깨어 있는 건 나랑 자네뿐이야. 늘 그렇지.',
        '자고 가. 아침까지는 아무 일 없게 해 줄게.'],
      re: [
        { t: '한 잔만 더.', s: '마지막이야. 매번 마지막이라고 하지만.' }] },
    dawn: { say: [
        '벌써 나가려고? 아침은 먹고 가.',
        '해 뜨는 거 보고 가. 이 도시에서 그거 하나는 볼 만해.'],
      re: [
        { t: '아침은 됐어.', s: '그럼 물이라도 들고 가. 이건 안 받아.' }] },
    goal: { say: [
        '오늘은 방값 안 받을게. 대신 자고 가.',
        '마지막 하나 남았다며. 그럼 나가기 전에 뭐라도 먹어.'],
      re: [
        { t: '돌아와서 먹을게.', s: '그 말 지켜. 나 그 말 세고 있어.' }] },
    day: { say: [
        '어서 와. 오늘은 한 잔인가, 한 밤인가.',
        '언젠가 이 방들이 다 찰 거야. 나는 그날까지는 안 접어.',
        '간판을 새로 달까 하는데, 뭐라고 쓸지를 모르겠어.'],
      re: [
        { t: '간판 이름 하나 지어 줄까?', s: ['말해 보게. …아니, 됐어. 자네가 지으면 이상할 것 같아.'] }] }
  },

  seira: {
    grave: { say: [
        '벼려 준 물건을 흘리고 왔다고? …그건 확률 얘기가 아니라 태도 얘기야.',
        '가서 주워 와. 내가 만든 건 내가 다시 만들기 싫으니까.'],
      re: [
        { t: '미안해.', s: '나한테 미안할 건 없어. 자네 물건이잖아.' }] },
    hurt: { say: [
        '장비가 아니라 자네가 금 갔군. 그건 내가 못 고쳐.',
        '그 몸으로 재련해 봤자 손이 떨려서 실패해. 나 말고 자네가.'],
      re: [
        { t: '그래도 벼려 줘.', s: '…한 번만. 실패해도 오늘은 값 안 받을게.' }] },
    bloodmoon: { say: [
        '붉은 밤엔 재련이 잘 된다는 말이 있어. 미신이야. …그런데 나는 오늘 좀 더 걸어.',
        '풀무 소리가 오늘따라 낮아. 불도 저 달을 아는 건가 싶고.'],
      re: [
        { t: '미신 아니야?', s: '미신이야. 그런데 나도 오늘은 한 번 더 돌려.' }] },
    sandstorm: { say: [
        '모래가 들어가면 쇳물이 못 쓰게 돼. 오늘은 안 벼려.',
        '풀무에 모래 한 줌이면 하루가 날아가. 그래서 오늘은 쉬는 거야.'],
      re: [
        { t: '쉬는 날인가?', s: '풀무 청소하는 날이지. 쉬는 날은 없어.' }] },
    dawn: { say: [
        '밤새 살려 둔 불이 지금 제일 좋아. 벼릴 거면 지금.',
        '해 뜨기 전 한 시간, 그때가 손이 제일 정확해.'],
      re: [
        { t: '지금 부탁할게.', s: '그럼 앉아. 불이 제일 좋을 때야.' }] },
    rain: { say: [
        '비 오는 날엔 불을 살려 두기가 어려워. 대신 식히기는 좋고.',
        '습하면 쇠가 잘 안 먹어. 오늘 실패해도 나 원망하지 마.'],
      re: [
        { t: '그럼 다음에.', s: '그래. 오늘 하면 자네가 나를 원망할 거야.' }] },
    chdone: { say: [
        '뭘 끝내고 왔군. 그럼 이제 장비를 다시 볼 때야.',
        '한 고비 넘겼으면 다음 고비는 장비가 정해. 그게 내 일이고.'],
      re: [
        { t: '뭘 먼저 손봐야 할까?', s: '맞는 걸 줄이는 것부터. 때리는 건 그 다음이야.' }] },
    broke: { say: [
        '돈 없이 재련하러 오면 곤란해. 운도 돈으로 사는 거야.',
        '공짜로 해 준 적 없어. 앞으로도 없을 거고.'],
      re: [
        { t: '다음에 올게.', s: '응. 돈 들고 와. 나는 안 도망가.' }] },
    rich: { say: [
        '오, 오늘은 여러 번 돌릴 수 있겠군. 여러 번 돌리면 결국 오르긴 해.',
        '돈이 많으면 확률이 착해 보여. 그건 착시야. 알고나 써.'],
      re: [
        { t: '결국 오른다는 거지?', s: ['결국은. 문제는 그 결국이 언제냐는 거고.', '나는 그걸 모른다고 미리 말했다.'] }] },
    night: { say: [
        '밤에 벼린 게 더 잘 나온다는 말도 있어. 통계로는 아니야.',
        '풍차 덕에 밤에도 불을 살려 둬. 잠은 낮에 자고.'],
      re: [
        { t: '낮에 자면 안 피곤해?', s: '피곤하지. 그런데 밤이 조용해서 손이 덜 떨려.' }] },
    goal: { say: [
        '마지막이라며. 그럼 장비를 한 번 더 볼 때야.',
        '지금 실패하면 다시 벼릴 시간이 없어. 그러니 지금 해.'],
      re: [
        { t: '한 번만 더 돌려 줘.', s: '…한 번만. 나도 오늘은 손이 떨리네.' }] },
    day: { say: [
        '들고 온 거 있어? 없으면 구경만 하고 가.',
        '올릴 수 있냐고 묻지 마. 올라갈 수도 있냐고 물어.',
        '내 손은 정직해. 정직하다고 다 좋은 건 아니지만.'],
      re: [
        { t: '올라갈 수도 있어?', s: ['있어. 내려갈 수도 있고.', '그게 정직한 대답이야.'] }] }
  },

  kade: {
    grave: { say: [
        '어디에 흘렸는지 좌표를 말해 보게. …농담이야. 그런 걸 재는 기계는 아직 없어.',
        '물건이 어디 있는지 아는 기계를 만들면 이 도시가 부자가 될 텐데 말이지.'],
      re: [
        { t: '농담 아니고 필요해.', s: '…만들어 볼게. 기대는 하지 말고.' }] },
    hurt: { say: [
        '자네 지금 걷는 소리가 이상해. 관절 어디 하나가 어긋난 거야.',
        '사람 몸은 도면이 없어서 곤란해. 있으면 내가 고쳐 줬을 텐데.'],
      re: [
        { t: '도면이 있으면 고쳐 줄 거야?', s: '고칠 거야. 그래서 안 만드는 걸지도 모르지.' }] },
    bloodmoon: { say: [
        '저 달 뜬 밤엔 포탑 조준이 어긋나. 붉은 빛이 렌즈를 속이는 거지.',
        '오늘은 성벽 계통을 하나씩 다시 봐. 나가려거든 문 쪽으로 가.'],
      re: [
        { t: '조준을 손볼 수 있어?', s: '렌즈를 갈아야 해. 그건 자네가 유적에서 하나 주워 와야 하고.' }] },
    sandstorm: { say: [
        '옷에 모래가 잔뜩이군. 사구가 통째로 움직였다지?',
        '그 모래, 좀 남겨 두게. 유리로 뽑아 볼 데가 있어.'],
      re: [
        { t: '모래 여기 있어.', s: '좋아. 이걸로 렌즈를 뽑으면 붉은 달에도 안 속을지 몰라.' }] },
    sporebloom: { say: [
        '포자가 접점에 앉으면 통전이 이상해져. 살아 있는 게 회로에 붙는 셈이니까.',
        '오늘은 환기구를 다 막아 뒀어. 도시가 숨을 참는 중이지.'],
      re: [
        { t: '환기구를 열면?', s: '포자가 들어와. 그러면 도시가 숨을 쉬다가 기침을 하겠지.' }] },
    rich: { say: [
        '돈이 있으면 부품을 쟁여 두게. 급할 때 없는 게 제일 비싸.',
        '자네가 부자면 이 도시가 부자야. 다른 사람이 없거든.'],
      re: [
        { t: '부품 좀 사 둘게.', s: '현명해. 나중에 나한테 되팔 때도 잘 쳐줄게.' }] },
    dawn: { say: [
        '밤새 붙잡고 있던 게 방금 됐어. 자네가 첫 손님이군.',
        '새벽에 전압이 제일 안정적이야. 아무도 안 쓰니까.'],
      re: [
        { t: '뭐가 됐는데?', s: '포탑 조준 보정. 이제 새는 안 쏴.' }] },
    rain: { say: [
        '전주 선로에 물이 들어가면 곤란해. 오늘은 하루 종일 사다리 위야.',
        '비 맞은 채로 배터리 근처에 서지 말게. 진심으로 하는 말이야.'],
      re: [
        { t: '사다리 잡아 줄게.', s: '…고맙군. 사실 그게 제일 무서웠어.' }] },
    chdone: { say: [
        '뭔가 끝냈군. 표정보다 걸음이 먼저 말해 줘.',
        '자네가 하나 끝낼 때마다 이 도시의 도면이 한 장씩 채워지는 기분이야.'],
      re: [
        { t: '도면이 뭔데?', s: ['내가 그리는 거야. 이 도시가 어떻게 생겼는지.', '다 그리면 누가 지었는지도 알게 되겠지.'] }] },
    broke: { say: [
        '부품은 외상이 안 돼. 대갈못 하나도 어디서 왔는지 다 세거든.',
        '돈이 없으면 고물을 가져오게. 나한테는 그게 더 반가워.'],
      re: [
        { t: '고물이면 뭐든 돼?', s: '뭐든. 특히 안 쓰는 거. 사람들은 안 쓰는 걸 제일 안 버리거든.' }] },
    night: { say: [
        '밤에 작업하는 게 나아. 낮엔 사람이 말을 걸어서. …자네 말고.',
        '이 시간엔 도시가 조용해. 그러면 벽 안에서 나는 소리가 들리거든.'],
      re: [
        { t: '도와줄까?', s: '손 하나면 돼. 여기 잡고 있어 봐.' }] },
    goal: { say: [
        '남은 게 하나면 부품을 다 채워 가게. 아끼다 죽는 사람 많이 봤어.',
        '포탑에 대갈못을 채워 뒀어. 자네가 나가는 길은 뚫려 있을 걸세.'],
      re: [
        { t: '든든하군.', s: '인사는 돌아와서 하게. 미리 받으면 부정 타.' }] },
    day: { say: [
        '마침 잘 왔네. 손이 하나 모자랐거든. …농담이야, 반은.',
        '벽 안쪽에 배선이 있어. 우리가 깐 게 아니고, 아직 살아 있어.',
        '유적 문양이랑 이 도시 문양이 같아. 우연이라기엔 획순까지 같더군.'],
      re: [
        { t: '뭘 알아냈어?', s: ['벽 안쪽 배선이 아직 살아 있다는 것. 그리고 그게 어디로 가는지는 모른다는 것.', '두 번째가 더 중요해.'] }] }
  }
};
